---
fr:
  downtime_events:
    auto_notice: Les périodes d'interruption ne tiennent pas compte de la planification de l'optimisation pour les centrales électriques avec réservoir
    available: Available
    capacity_impact: Impact sur la capacité
    chart_monthly_heading: Raisons pour les interruptions mensuelles
    chart_volume_heading: Production et interruptions
    chart_yearly_heading: Raisons pour les interruptions annuelles
    components:
      control_system: Système de contrôle
      external_grid: Réseau externe
      fiber_and_communication: Fibre et communication
      foundation: Fondation
      generator: Générateur
      hardstand: Hardstand
      high_voltage_system: Système à haute tension
      intake: Prise d'eau
      internal_grid: Réseau interne
      inverter: Onduleur
      logger: Enregistreur
      module: Module
      other: Autre
      pyranometer: Pyranomètre
      road: Route
      string: Chaîne
      substation: Sous-station
      transformer: Transformateur
      turbine: Turbine
      waterway: Voie d'eau
    create: Créer
    deletion_failed: Échec de la suppression de la période d'indisponibilité
    downtime_event: Périodes d'indisponibilité
    edit: Éditer l'interruption technique
    email:
      body:
        contact: Contactez %{name} pour plus d'informations
        info: Une nouvelle période d'arrêt a été programmée. Veuillez en tenir compte dans votre exploitation de cette centrale électrique.
    email_to_operator: Envoyer un e-mail à l'opérateur
    est_downtime_cost: Coût est.
    est_downtime_hours: Heures est.
    est_loss: Est. perte
    est_lost_prod_vol: Pertes de prod. est.
    est_revenue: Est. revenu
    est_vol_hr: Vol. est./hr
    filter_out_no_water: Filtrer pas d'eau
    model_name: Périodes d'interruption
    model_name_plural: Périodes d'interruption
    model_name_short: Interruption
    no-data-text: Aucune donnée disponible - sélectionnez une centrale électrique
    no_hours: Heures affectées
    no_match: Les paramètres sélectionnés ne correspondent à aucune centrale.
    not_specified: Pas spécifié
    reasons:
      commercial_price: Commercial/Prix
      effect_restriction: Restriction d'effet
      external_grid: Réseau électrique externe
      grid: Réseau externe
      no_water: Pas d'eau
      operational_loss: Perte opérationnelle
      overflow: Débordement
      planned_maintenance: Maintenance planifiée
      reservoir: Réservoir
      technical: Technique
      uncategorized: Non catégorisé
      unplanned_maintenance: Maintenance non planifiée
      water_loss: Perte d'eau
      wind: Éolien
    scheduled_downtime_event: Période d'interruption planifiée
    scheduled_downtime_events_name: Périodes d'interruption planifiées
    scheduled_downtime_for: Période d'interruption planifiée pour
    see_stats: Choisissez une centrale électrique pour voir les statistiques
    tab_downtime: Événements d'interruption
    tab_environmental_flow: Événements de débit environnemental
    tech_downtime: Interruption technique
    tech_downtime_short: Inter. technique
    unavailable: Unavailable
    verified_event_cannot_be_deleted: Les périodes d'indisponibilité vérifiées ne peuvent pas être supprimées
    verified_event_change_confirmation: Cette période d'indisponibilité a été vérifiée. La modifier peut affecter les rapports et les calculs. Voulez-vous continuer ?
    water_level: Niveau d'eau
    water_level_unit: m
    water_loss_downtime: Interruption perte d'eau
  environmental_flow:
    actions: Actions
    assign_to: Attribuer à
    avg_flow: Débit moyen
    avg_violation: Violation moyenne
    comment: Description
    confirm_delete: Êtes-vous sûr de vouloir supprimer cet événement de débit environnemental?
    confirm_run_detection: Exécuter la détection de violations pour les 30 derniers jours? Cela peut prendre quelques minutes.
    corrective_volume: Volume (l/s) pour mesure corrective
    create_event: Créer un événement de débit environnemental
    current_image: Image actuelle
    delete_error: Impossible de supprimer l'événement. Les événements vérifiés ne peuvent pas être supprimés.
    detection_job_error: Échec du démarrage de la tâche de détection de violations. Veuillez réessayer.
    detection_job_started: Tâche de détection de violations démarrée. Les résultats apparaîtront sous peu.
    duration: Durée
    ends_at: Heure de fin
    event: événement de débit environnemental
    event_created: Événement de débit environnemental créé avec succès
    excluded: Exclu
    fetch_data_error: Échec du chargement des données de débit environnemental. Veuillez réessayer.
    fetch_drilldown_error: Échec du chargement des données détaillées. Veuillez réessayer.
    fetch_error: Échec du chargement des événements de débit environnemental. Veuillez réessayer.
    fetch_events_error: Échec du chargement des événements de débit environnemental. Veuillez réessayer.
    fetch_latest_value_error: Échec du chargement de la dernière valeur du capteur. Veuillez réessayer.
    fetch_threshold_error: Échec du chargement des données de seuil. Veuillez réessayer.
    further_corrective_measures: Mesures correctives supplémentaires
    generate_task: Générer une tâche
    hide_excluded: Masquer les exclus
    image: Image
    immediate_measures: Mesures immédiates
    linked_task: Tâche liée
    min_flow: Débit minimum
    no_responsibles_available: Aucun responsable disponible. Veuillez configurer au moins un responsable d'entreprise pour cette centrale électrique.
    power_plant: Centrale électrique
    reporter_name: Nom du rapporteur
    run_detection: Détecter les violations
    show_excluded: Afficher les exclus
    starts_at: Heure de début
    threshold: Seuil
    title: Violations de débit environnemental
    total_events: Nombre total d'événements
    total_hours: Nombre total d'heures
    update_comment_error: Échec de la mise à jour de la description. Veuillez réessayer.
    update_excluded_error: Échec de la mise à jour du statut d'exclusion. Veuillez réessayer.
    update_further_corrective_measures_error: Échec de la mise à jour des mesures correctives supplémentaires. Veuillez réessayer.
    update_immediate_measures_error: Échec de la mise à jour des mesures immédiates. Veuillez réessayer.
    update_reporter_name_error: Échec de la mise à jour du nom du rapporteur. Veuillez réessayer.
    update_verification_error: Échec de la mise à jour du statut de vérification. Veuillez réessayer.
    verified: Vérifié
    view_image: Voir l'image
    violation_pct: Violation %
